import { Component, ViewChild, Inject, NgZone } from '@angular/core';
import { EServicesBase, CustomTab } from 'Shared/eservices-base/eServices-base';
import { Suggestion } from '../models/suggestion';
import { NgForm } from '@angular/forms';
import { DocumentModel } from 'Shared/Uploader/Models/DocumentModel';
import { CommonService } from 'Shared/services/common-service/common.service';
import { ResourceService } from 'Shared/services/resources-service/resource.service';
import { LookupService } from 'Shared/services/lookup-service/lookup.service';
import { PopupService } from 'Shared/modules/popup/popup.service';
import { DocumentService } from 'Shared/services/Document-service/document-service';
import { SuggestionService } from './suggestion.service';
import { LookupEntity } from 'Shared/models/lookup-entity';
import { LookupType } from 'Shared/enums/lookup-Type.enum';
import { DocumentEntity } from 'Shared/models/document-entity';
import { DocumentConfigurationEnum } from 'Shared/enums/document-configuration.enum';
import { RecaptchaLoaderService } from 'ng-recaptcha';
import { RecaptchaDynamicLanguageLoaderService } from 'Shared/services/Recaptcha/dynamic-language-loader.service';
import { LookupKeyValue } from 'Shared/models/lookup-key-value';
import { Observable, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { RecaptchaV3Service } from '../../../../Shared/services/Recaptcha/recaptchaV3.service';

@Component({
  selector: 'app-root',
  templateUrl: './suggestion.app.component.html',
  styleUrls: ['./suggestion.app.component.css']
})
export class SuggestionComponent extends EServicesBase<Suggestion> {
  @ViewChild('suggestionRequestForm') suggestionRequestForm: NgForm;
  @ViewChild('ViewForm') ViewForm: NgForm;
  birthDateOptions: any = {}
  attachments: DocumentModel[];
  isAttacmentValid: boolean = false;
  decisionOptions: any = [];
  isResendEnabled: boolean = true;
  secondsRemaining$: Observable<number>;
  constructor(protected applicationService: SuggestionService,
    protected resourceService: ResourceService,
    protected lookupService: LookupService, protected commonService: CommonService,
    protected modalService: PopupService,
    protected documentService: DocumentService,
    @Inject(RecaptchaLoaderService) private loader: RecaptchaDynamicLanguageLoaderService,
    private zone: NgZone, private recaptchaV3Service: RecaptchaV3Service) {
    super(applicationService, resourceService, lookupService, commonService, modalService, documentService)
    this.Application = new Suggestion();
  }
  protected tabs(): CustomTab[] {
    return [{
      tabIndex: 1,
      formName: "suggestionRequestForm",
      form: this.suggestionRequestForm,
      isTabValid: this.validateSuggetionRequestForm
    }];
  } protected TApplicationNewInstance(): Suggestion {
    return new Suggestion();
  }
  protected getServiceFolder(): string {
    return "SuggestionService";
  }
  protected getResourcesFileName(): string {
    return "Resource";
  }

  beforeInitForm() {
    this.recaptchaV3Service.loadRecaptchaV3();
  }
  protected extendInitForm(): void {
    const now = Date.now();
    const days = 18 * 365 * 24 * 60 * 60 * 1000;
    this.birthDateOptions.enabledDateRanges = [{ start: new Date(new Date().getFullYear() - 200, new Date().getMonth(), new Date().getDate()), end: new Date(now - 1 * days) }];
    this.birthDateOptions.language = this.resourceService.getCurrentLanguagePrefix();
    this.getSuggestionDecision();
  }
  protected getLookupTypes(): LookupEntity[] {
    let lookups: LookupEntity[] = [
      {
        lookupType: LookupType.CRMCountry,
        name: "Country",
        customUrl: ""
      },
      {
        lookupType: LookupType.CRMCaseRegardingSuggestion,
        name: "SuggestionSubject",
        customUrl: ""
      }
    ];
    return lookups;
  }
  protected afterResourcesLoaded(): void {
    this.loader.updateLanguage(this.resourceService.getCurrentLanguagePrefix());
  }
  protected getDocumentConfigurations(): DocumentEntity[] {
    let documentConfigurations: DocumentEntity[] = [
      {
        name: "Documents",
        documentConfiguration: DocumentConfigurationEnum.Defualt,
        customUrl: "",
      }
    ];
    return documentConfigurations;
  }
  validateSuggetionRequestForm(self: any): boolean {
    if (self.Application.IsSubmitted) {
      if (self.isAttacmentValid && self.Application.DateOfBirth)
        return true;
    }
  }
  IsAttachmentIdVaild(event) {
    this.isAttacmentValid = event;
  }
  getFilesId() {
    this.Application.Attachments = new Array<DocumentModel>();
    if (this.attachments != undefined && this.attachments.length > 0) {
      if (this.attachments.length == 1) {
        this.Application.AttachmentId = this.attachments[0].TempId != "" && this.attachments[0].TempId != null ? this.attachments[0].TempId : this.attachments[0].RealId;
      }
      else {
        let list = this.attachments.filter(a => !a.IsDeleted);
        this.Application.AttachmentId = list[0].TempId != "" && list[0].TempId != null ? list[0].TempId : list[0].RealId;
      }
      for (var i = 0; i < this.attachments.length; i++) {
        this.Application.Attachments.push(this.attachments[i]);
      }
    }
  }
  extendHandleRetrievedApplication(application: Suggestion): void {
    if (application.Attachments) {
      if (application.AttachmentId) {
        this.attachments = new Array<DocumentModel>();
        let items = application.Attachments.filter(a => a.RealId == application.AttachmentId);
        if (items.length > 0)
          this.attachments.push(items[0])
      }
    }
    if (!this.commonService.currentUser.IsAnonymous && !this.applicationId) {
      this.Application.Request.RequestorEmail = this.commonService.currentUser.ApplicantEmail;
      this.Application.Request.RequestorEmiratesId = this.commonService.currentUser.EmiratesID;
      this.Application.FirstName = this.commonService.currentUser.FirstName;
      this.Application.LastName = this.commonService.currentUser.LastName;
      this.Application.IsCitizen = this.commonService.currentUser.IsUAECitizen;
      if (!this.commonService.currentUser.IsUAECitizen) {
        if (this.commonService.currentUser.EmiratesID) {
          this.Application.IsResident = true;
        }
        else {
          this.Application.IsResident = false;
        }
      }
      // this.Application.Request.RequestorMobileNumber = this.commonService.currentUser.Mobile;
      this.Application.Request.RequestorName = this.commonService.currentUser.Fullname;
      if (this.commonService.currentUser.DateOfBirth)
        this.Application.DateOfBirth = this.commonService.currentUser.DateOfBirth.split('T')[0]
    }
    if (this.commonService.currentUser.IsAnonymous && this.commonService.currentUser.IsBackEndUser && !this.applicationId)
      this.Application.IsAnonymous = true;
    this.Application.DecisionId = null;
    if (application.PreferredCommunication)
      this.Application.PreferredCommunication = parseInt(application.PreferredCommunication.toString());
    //remove duplicate from case regarding
    //this.isFormReadyEventEmitter.subscribe(result => {
    //  let tempRegarding: LookupKeyValue[] = [];
    //  this.lookupService.lookupEntities[this.lookupType.CRMCaseRegardingSuggestion].forEach((item, index) => {
    //    if (tempRegarding.findIndex(i => i.Name == item.Name) === -1) {
    //      tempRegarding.push(item)
    //    }

    //  });
    //  this.lookupService.lookupEntities[this.lookupType.CRMCaseRegardingSuggestion] = tempRegarding;
    //})
  }
  protected preSubmitApplication(): void {
    this.getFilesId();
    let countries: any = {};
    let decision: any = {};
    this.Application.PreferredCommunication=2
    if (this.Application.IsAnonymous) {
      //if (this.Application.FirstName)
      //  this.Application.FirstName = this.Application.FirstName.trim();
      //if (this.Application.LastName)
      //  this.Application.LastName = this.Application.LastName.trim();
      if (!this.Application.Request.RequestorName || this.Application.Request.RequestorName.trim() == "")
        this.Application.Request.RequestorName = this.Application.FirstName + " " + this.Application.LastName;
    }
    else {
      this.Application.FirstName = this.Application.Request.RequestorName;
    }
    countries = this.lookupService.lookupEntities[LookupType.CRMCountry];
    if (this.Application.IsCitizen)
      this.Application.Request.CountryId = countries.filter(a => a.IsUAE == true)[0].Key;
    decision = this.decisionOptions.filter(a => a.Key == this.Application.DecisionId);
    this.Application.DecisionAr = decision.length > 0 ? decision[0].NameAr : null;
    this.Application.DecisionEn = decision.length > 0 ? decision[0].NameEn : null;
  }
  getSuggestionDecision() {
    this.decisionOptions = [
      {
        Key: 1,
        Name: this.resources['lbl_ValidSuggestionWI'],
        NameAr: "سيتم تنفيذ اقتراح صالح",
        NameEn: "Valid suggestion will be implemented"
      },
      {
        Key: 2,
        Name: this.resources['lbl_ValidSuggestionWNI'],
        NameAr: "لن يتم تنفيذ اقتراح صالح",
        NameEn: "Valid suggestion will not be implemented"
      },
      {
        Key: 3,
        Name: this.resources['lbl_InvalidSuggestion'],
        NameAr: "اقتراح غير صالح",
        NameEn: "Invalid Suggestion"
      }]
  }
  backAnonymous() {
    this.isBack = true;
    if (this.commonService.currentUser.IsAnonymous && this.commonService.currentUser.IsBackEndUser) {
      this.modalService.close("genericErrorPopup");
      window.location.href = this.commonService.baseUrl;
    }
    else {
      this.backToWorkSpace();
    }
  }

  //setTimeout(() => {
  //  for (const key in this.suggestionRequestForm.controls) {
  //    if (this.suggestionRequestForm.controls[key]) {
  //      this.suggestionRequestForm.controls[key].markAsPristine();
  //    }
  //  }
  //});


  isValidInformationChange(isvalid: boolean) {
    if (isvalid && this.isResendEnabled) {
      this.ResendVertificationCode();
    }
  }

  ResendVertificationCode() {
    if (this.isResendEnabled &&
      this.Application.Request.RequestorEmail &&
      this.Application.Request.RequestorEmail != "") {
      this.isResendEnabled = false;
      this.commonService.sendToken(this.Application.Request.RequestorEmail).subscribe(result => {
        var seconds = 60;
        this.secondsRemaining$ = timer(0, 1000).pipe(
          map(n => {
            let remainingSeconds = (seconds - n) * 1000;
            if (remainingSeconds == 0)
              this.isResendEnabled = true;
            return remainingSeconds;
          }),
          takeWhile(n => n >= 0),
        );
      })
    }
  }

  protected onSaveApplicationError() {
    grecaptcha.reset();
    this.Application.ReCaptchaResopnse = null;
  }

  public submitForm(): void {
    this.recaptchaV3Service.getToken().then((token) => {
      this.Application.ReCaptchaResopnse = token;
      super.submitForm();
    });
  }
}
